import { Pipe, PipeTransform } from '@angular/core';
import { InstallationGroundLevelPluginService } from './ground-level.service';
@Pipe({
    name: 'leveltype',
    standalone: false
})
export class LevelTypePipe implements PipeTransform {
  public levelTypes: any[];
  constructor(private service: InstallationGroundLevelPluginService) {
    this.levelTypes = this.service.getLevelTypes();
  }
  transform(id: string): any {
    return this.service.getValue(parseInt(id), this.levelTypes);
  }
}
